<section class="tenure-attachment-container">
    <div class="header">
        <header class="panel-header">Tenure Attachments</header>
        <button class="close-btn" type="button" (click)="onCloseClicked()" title="Cancel">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="attachment-info">
        <div class="row-element">
            <span class="label">{{'spin Id' | camelCase}}</span>
            <span>:	&nbsp;</span>
            <span class="value">{{data['spinId']}}</span>
        </div>
        <div class="row-element">
            <span class="label">{{'uploaded document(s)' | camelCase}}</span>
            <span>:	&nbsp;</span>
            <div class="file-attachement">
                @if(!data['attachments'] || data['attachments'].length <= 0){ 
                    <span >{{'No Attachment Found' | camelCase}}</span>
                }@else{
                    @for(file of data['attachments']; track idx; let idx = $index){
                    <span class="attachment-links">
                        <span class="attachment-name" [title]="file['displayName'] | camelCase">{{idx + 1}}. {{file['displayName'] | camelCase}}</span>
                        <span class="fa-solid fa-download" style="cursor: pointer;" title="download" (click)="downloadFile(file)"></span>
                    </span>
                    }
                }
            </div>
        </div>
    </div>
</section>
<app-spinner [spinnerName]="spinnerName"></app-spinner>